// Module
var code = "<div/> ";
// Exports
module.exports = code;